import { useEffect } from "react";
import AboutCapitalAcres from "./components/AboutCapitalAcres";
import AboutDeveloper from "./components/AboutDeveloper";
import Amenities from "./components/Amenities";
import BestQuotes from "./components/BestQuotes";
import Carousel from "./components/Carousel";
import Details from "./components/Details";
import FloorPlan from "./components/FloorPlan";
import Footer from "./components/Footer";
import Form from "./components/Form";
import Header from "./components/Header";
import Hero from "./components/Hero";
import NewForm from "./components/NewForm";
import Pricing from "./components/Pricing";

import StripSection from "./components/StripSection";
import LocationBenefits2 from "./components/LocatiopnBenefits2";
import Modal1 from "./components/Modal1";

function App() {
  useEffect(() => {
    // Disable right-click
    const handleContextMenu = (e) => e.preventDefault();

    // Disable F12 and Ctrl+Shift+I
    const handleKeyDown = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i")
      ) {
        e.preventDefault();
      }
    };

    // Attach event listeners
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup event listeners
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []); // Empty array means it runs once on mount
  return (
    <>
      <div className="App">
        <Header />
        <Hero />
        <NewForm />
        <StripSection />
        <Details />
        <Pricing />
        <FloorPlan />
        <Amenities />
        <Carousel />
        <LocationBenefits2 />
        <AboutDeveloper />
        <AboutCapitalAcres />
        <BestQuotes />
        <Footer />
        <Form />
        <Modal1 />
      </div>
    </>
  );
}

export default App;
